export const BoxShadows = {
  default: "0 2px 4px 0 #283c5d29",
  interactive: "0 0 16px 4px #283c5d29",
  hover: "0 0px 32px 8px #283c5d29",
};

export type BoxShadowName = keyof typeof BoxShadows;
